import iDuck from "../../../assets/img/abous-us-page/hero-duck.png";
import iHeroBg from "../../../assets/icons/about-us-page/hero-bg.svg";
import iHeroBgMobile from "../../../assets/icons/about-us-page/hero-bg-mobile.svg";
import iWave from "../../../assets/icons/about-us-page/wave.svg";
import { useWidth } from "../../../hooks/use-width";
import "./about-us-hero-block.sass";

const AboutUsHeroBlock = () => {
  const { isDesktopWidth } = useWidth();
  return (
    <div className="about-us-hero-block">
      <div className="about-us-hero-block__block">
        <div className="about-us-hero-block__title">Привет, мы Creon</div>

        <div className="about-us-hero-block__text">
          cоздаём сильные коммуникационные решения для брендов, и на нас можно
          положиться
        </div>
      </div>

      <img
        src={iDuck}
        className="img-absolute about-us-hero-block__duck"
        alt=""
      />

      {isDesktopWidth && (
        <img
          src={iHeroBg}
          className="img-absolute about-us-hero-block__hero-bg"
          alt=""
        />
      )}

      {!isDesktopWidth && (
        <img
          src={iHeroBgMobile}
          className="img-absolute about-us-hero-block__hero-bg"
          alt=""
        />
      )}

      <div className="about-us-hero-block__background" />
      <img
        src={iWave}
        className="img-absolute about-us-hero-block__wave"
        alt=""
      />
    </div>
  );
};

export default AboutUsHeroBlock;
